'use client'
import EyeSVG from '@local/assets/svgs/icon-eye.svg'
import {useRef} from 'react'
import {SlideshowNative, SanityImage} from '@local/ui/components'
import {SanityImageType} from '@local/types'

interface TrustBadgeProps {
	caption: string
	title: string
	image: SanityImageType
}

interface TrustBadgesContentProps {
	entries: Array<TrustBadgeProps>
}

export const TrustBadgesContent = ({entries}: TrustBadgesContentProps) => {
	const slideshowRef = useRef<HTMLDivElement>(null)
	return (
		<div className='text-black  border-t border-grey-1/80 py-60 px-20'>
			<div className='hidden flex-row justify-between items-center gap-20 lg:flex '>
				{entries.map((entry) => (
					<div key={entry.title} className='flex flex-col '>
						<div className='flex items-center gap-10'>
							<SanityImage
								image={entry.image}
								alt={entry.title}
								width={20}
								height={20}
								className='w-20 h-auto object-cover aspect-square' />
							<h3 className='text-12 font-sans font-medium text-black uppercase'>{entry.title}</h3>

						</div>
						<p className='text-12 font-sans  text-grey-2 max-w-[300px] mt-5'>{entry.caption}</p>
					</div>
				))}
			</div>
			<SlideshowNative
				disableObserver
				ref={slideshowRef}
				withDotNavigation
				dotNavigationClassName='mt-24 lg:hidden'
				className='lg:hidden'>
				{entries.map((entry) => (
					<div key={entry.title} className='flex flex-col items-center   max-w-full'>
						<div className='flex gap-8 pb-10'>
							<EyeSVG className='w-20 h-auto' />
							<h3 className='text-12 font-sans font-medium text-center text-black uppercase'>{entry.title}</h3>
						</div>
						<p className='text-12 font-sans text-center text-grey-2'>{entry.caption}</p>
					</div>
				))}
			</SlideshowNative>
		</div>
	)
}
